import { type ClassValue, clsx } from "clsx"
import { twMerge } from "tailwind-merge"

export function cn(...inputs: ClassValue[]) {
  return twMerge(clsx(inputs))
}

/**
 * Convert an absolute upload URL to a relative path.
 * Ensures `<img>` requests go to the same origin as the page,
 * avoiding cross-origin issues when the API URL differs from the frontend URL.
 *
 * Examples:
 *   "https://demo.amuster.com/uploads/tenant-branding/abc/img.webp" → "/uploads/tenant-branding/abc/img.webp"
 *   "/uploads/platform-branding/img.webp" → "/uploads/platform-branding/img.webp" (unchanged)
 *   "blob:http://..." → "blob:http://..." (unchanged, blob URLs are already local)
 */
export function toRelativeUploadUrl(url: string | null | undefined): string | null {
  if (!url) return null;
  // Blob URLs are always local — return as-is
  if (url.startsWith('blob:')) return url;
  // Already relative
  if (url.startsWith('/')) return url;
  try {
    const parsed = new URL(url);
    // Only convert URLs that point to /uploads/ paths
    if (parsed.pathname.startsWith('/uploads/')) {
      return parsed.pathname;
    }
    return url;
  } catch {
    return url;
  }
}
